import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const TrackContext = createContext({ tracks: [], activeTrack: null, activeId: "", setActive: () => {}, reload: () => {} });

export function TrackProvider({ children }) {
  const { user } = useAuth();
  const [tracks, setTracks] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem("wp_track_id") || "");

  const load = () => {
    if (!user) { setTracks([]); return; }
    api.get("/tracks").then((r) => {
      setTracks(r.data);
      const stored = localStorage.getItem("wp_track_id");
      if (stored && !r.data.find((t) => t.id === stored)) {
        localStorage.removeItem("wp_track_id");
        setActiveId("");
      }
    }).catch(() => {});
  };
  useEffect(load, [user]);

  const setActive = (id) => {
    if (id) localStorage.setItem("wp_track_id", id);
    else localStorage.removeItem("wp_track_id");
    setActiveId(id || "");
  };

  const activeTrack = tracks.find((t) => t.id === activeId) || (tracks.length === 1 ? tracks[0] : null);

  return (
    <TrackContext.Provider value={{ tracks, activeTrack, activeId, setActive, reload: load }}>
      {children}
    </TrackContext.Provider>
  );
}

export const useTracks = () => useContext(TrackContext);
